export const dateCellStyles = ({ palette = {} }) => ({
  '& span.dashed-date-entry': {
    borderBottom: palette.themePrimary ? `1px dashed ${palette.themePrimary}` : '1px dashed #0078d4',
  },
});

export const campaignManagedDateTooltipStyles = () => ({
  '#campaign-managed-date-tooltip-id .popover-content': {
    padding: '24px',
  },
});
